import React from 'react';
import { LeafIcon } from 'lucide-react';
export function ProblemSection() {
  const points = ['Sleep challenges often involve stress and daily habits.', 'Inflammation can be influenced by lifestyle and diet.', 'Digestive discomfort may come from many small daily factors.', 'Immune health benefits from consistent long-term support.'];
  return <section className="w-full bg-white py-16 md:py-24" data-id="element-615">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-616">
        <div className="text-center mb-10" data-id="element-617">
          <h2 className="text-3xl md:text-4xl font-bold text-stone-900 mb-4" data-id="element-618">
            Why Many People Look for Natural Options
          </h2>
          <div className="text-lg text-stone-600 max-w-2xl mx-auto leading-relaxed space-y-3" data-id="element-619">
            <p data-id="element-620">Many people rely on medications to manage everyday symptoms.</p>
            <p data-id="element-621">
              But others also choose to support their bodies with simple natural
              habits and traditional remedies.
            </p>
          </div>
        </div>

        <div className="max-w-xl mx-auto mb-8" data-id="element-622">
          <ul className="space-y-5" data-id="element-623">
            {points.map((point, index) => <li key={index} className="flex items-start gap-4" data-id="element-624">
                <LeafIcon className="w-6 h-6 text-emerald-600 flex-shrink-0 mt-0.5" data-id="element-625" />
                <span className="text-lg text-stone-700 font-medium" data-id="element-626">
                  {point}
                </span>
              </li>)}
          </ul>
        </div>

        <p className="text-lg text-stone-600 text-center max-w-2xl mx-auto leading-relaxed" data-id="element-627">
          Natural remedies have been used for generations to complement healthy
          living and support the body's natural balance.
        </p>
      </div>
    </section>;
}